const Structure = {
  RC: "鉄筋コンクリート",
  SRC: "鉄骨鉄筋コンクリート",
  WOOD: "木造",
  BLOCK: "ブロック",
  STEEL: "鉄骨造",
  PC: "プレキャストコンクリート",
  HPC: "鉄骨プレキャストコンクリート",
  LIGHT_STEEL: "軽量鉄骨",
  OTHER: "その他",
} as const;

export type IStructure = typeof Structure[keyof typeof Structure];

export const structureOptions = Object.values(Structure).map(value => ({
  label: value,
  value,
}));

export default Structure;
